import { useEffect, useState } from 'react';
import { isNativePlatform } from './native';
import { configureRevenueCat, getOfferings } from './revenuecat';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Format a Stripe minor-unit amount (e.g. 899, 'eur') as "€8.99". Null if unknown.
export const formatPrice = (amount, currency) => {
  if (amount == null || !currency) return null;
  try {
    return new Intl.NumberFormat('en-IE', {
      style: 'currency',
      currency: currency.toUpperCase(),
    }).format(amount / 100);
  } catch {
    return null;
  }
};

// Current Stripe checkout price for the web paywall.
export const useCheckoutPrice = () => {
  const [label, setLabel] = useState(null);
  useEffect(() => {
    let cancelled = false;
    fetch(`${API_URL}/api/subscription/price`)
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (!cancelled && d) setLabel(formatPrice(d.amount, d.currency)); })
      .catch((e) => console.error('[price] lookup failed', e));
    return () => { cancelled = true; };
  }, []);
  return label;
};

// Localised App Store / Play price string from RevenueCat (native only).
export const useStorePrice = (enabled, user) => {
  const [label, setLabel] = useState(null);
  useEffect(() => {
    let cancelled = false;
    if (!enabled || !isNativePlatform() || !user?.user_id) return undefined;
    (async () => {
      try {
        await configureRevenueCat(user);
        const offering = await getOfferings();
        const str = offering?.availablePackages?.[0]?.product?.priceString || null;
        if (!cancelled) setLabel(str);
      } catch (e) {
        console.error('[price] store lookup failed', e);
      }
    })();
    return () => { cancelled = true; };
  }, [enabled, user]);
  return label;
};
